<template>
  <div>
    <TheSheetQRDialogs :DialogAction="DialogAction" />

    <!-- 複数もぎりができる商材であれば、枚数選択のダイアログ表示 -->
    <DialogSelectMultiValidFramesCount
      ref="DialogSelectMultiValidFramesCount"
      @childMethod="decideCountOfMultiSheetValid"
    />

    <!-- 使用枚数確認ダイアログ -->
    <DialogValidFramesConfirmation
      ref="DialogValidFramesConfirmation"
      :count="storeCountOfMultiSheets"
      @okClicked="validFrameAndGetSheetInfo"
      @cancelClicked="confirmationCanceled"
    />
  </div>
</template>

<script>
// Vue
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

// Vueファイル
import DialogValidFramesConfirmation from "@/views/Components/Organisms/MyTickets/Dialog/DialogValidFramesConfirmation";

// Service
import bookService from "@/services/book";
import frameService from "@/services/frame";
import sheetService from "@/services/sheet";
import nativeHandlerService from "@/services/nativeHandler";

// API
import API from "@/API";

// JSプラグイン
import moment from "@/services/moment";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    let DialogAction = ref({ dialog: null, action: null });

    // 複数有効化商材の時の枚数選択ダイアログ
    const DialogSelectMultiValidFramesCount = ref(null);
    // 選択された枚数の確認ダイアログ
    const DialogValidFramesConfirmation = ref(null);

    // 有効化される予定のフレームを配列で持つ
    let multiSheetValidIdsArray = ref(null);

    const bookGroup = store.getters["ticketing/bookGroup"];
    const masterBook = store.getters["ticketing/masterBook"];
    const book = store.getters["ticketing/book"];
    const sheet = store.getters["ticketing/sheet"];
    const masterSheet = store.getters["ticketing/masterSheet"];
    const frame = store.getters["ticketing/frame"];

    onMounted(async () => {
      try {
        // Storeにbook情報がなければ、シートフローの中で必要なAPIを取得し、それぞれのデータをstoreへcommit
        if (book.length == 0) {
          await sheetService.getSheetInfomations(route);
        }
        actionDialog("DialogLoading", true);

        if (route.query.type == "normal") {
          console.log("route.query.type :>> normal");
          //複数モギリ可能かつ未選択の場合はダイアログフラグをtrueにして枚数選択UI表示
          if (
            book.master_limits[0].max_concurrent_punching > 1 &&
            multiSheetValidIdsArray.value == null
          ) {
            DialogSelectMultiValidFramesCount.value.openDialog();
          } else {
            // そうでない場合はそのまま単数有効化
            validFrameAndGetSheetInfo();
          }
        } else if (route.query.type == "mamoru") {
          console.log("route.query.type :>> mamoru");

          // type=="mamoru"ならメニュー選択が必要になる
          router.push({
            name: "SheetMenu",
            query: {
              book_group_id: route.params.book_group_id,
              sheet_id: route.params.sheet_id,
              onetime: route.query.onetime,
              mamoru_auth: route.query.mamoru_auth,
              location_id: route.query.location_id,
            },
          });
        }
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "SheetValid onMounted()",
          JSON.stringify(err)
        );
      }
    });

    const validFrameAndGetSheetInfo = async () => {
      // 有効化APIを統括的に叩く関数
      if (await executeValidAPI()) {
        // 最新の情報へアップデート
        await sheetService.getSheetInfomations(route);

        // 成功ダイアログ表示
        actionDialog("DialogLoading", false);
        actionDialog("DialogValidFramesWithQRComplete", true);
      }
    };

    const issueExternalCoupon = async () => {
      //issue external coupon when using sheet ticket
      try {
        const numberCouponIssued = await API.issueExternalCoupon(
          masterBook.id,
          book.id
        );

        if (numberCouponIssued > 0) {
          store.commit("ticketing/setIssuedExternalCouponStatusOfSheet", true);
        } else {
          store.commit("ticketing/setIssuedExternalCouponStatusOfSheet", null);
        }
      } catch (err) {
        store.commit("ticketing/setIssuedExternalCouponStatusOfSheet", false);
        console.log("SheetValid :>> issue coupon fail");
      }
    };

    // type==normalの券種の有効化メソッド
    const executeValidAPI = async () => {
      console.log("executeValidAPI :>> start");
      console.log("frame :>> ", frame);
      try {
        const validBookInAdvance = masterSheet.ignore_book_valid == false;
        // ブック自体を初めて使う場合はブックをvalidにする処理を挟む
        if (validBookInAdvance && !book.is_valid) {
          await bookService.executeValidBooks(
            bookGroup,
            masterBook.is_multi_validatable
          );
          await issueExternalCoupon();
        }
        // MJのデータが複数モギリ可能と示唆しているか
        const isMultiValidable =
          book.master_limits[0].max_concurrent_punching > 1;
        console.log("isMultiValidable :>> ", isMultiValidable);

        // POSTの際のリクエストに設定するFrameIDを求める関数
        let apiFrame = await frameService.checkApiFrame(
          masterSheet,
          frame,
          isMultiValidable
        );

        if (apiFrame == "isMultiValidable") {
          console.log(
            "MultiVFrame multiSheetValidIdsArray",
            multiSheetValidIdsArray
          );
          // 複数有効化
          await API.validFramesWithQR(
            multiSheetValidIdsArray.value,
            route.query.location_id
          );
        } else if (apiFrame == "SubscriptionAndEmpty") {
          console.log("sheet.velue :>> ", sheet);
          // サブスクかつフレームが空であればPOST APIでフレームを新規作成する必要があり、そのレスポンスを代入
          apiFrame = await API.postFrames(sheet);

          console.log("executeValidAPI apiFrame :>> ", apiFrame);
          // 使用枚数を1で固定
          store.commit("ticketing/setStoreCountOfMultiSheets", 1);
          await API.validFrameWithQR(apiFrame.id, route.query.location_id);
        } else if (apiFrame == "normal") {
          if (bookGroup.books.length > 1) {
            let frameArray = [];
            // frameのListを抽出
            for (let i = 0; i < bookGroup.books.length; i++) {
              for (let s = 0; s < bookGroup.books[i].sheets.length; s++) {
                if (
                  bookGroup.books[i].sheets[s].master_sheet_id == masterSheet.id
                ) {
                  let [return_used_frames, return_unused_frames] =
                    await frameService.setMultipleFrame(
                      bookGroup.books[i].sheets[s]
                    );
                  frameArray.push({ id: return_unused_frames[0].id });
                }
              }
            }
            console.log("MultiBooks SingularFrame", frameArray);
            await API.validFramesWithQR(frameArray, route.query.location_id);
          } else {
            // 普通のシートであればすでにstoreに指定されたframeを代入
            apiFrame = frame;
            console.log("executeValidAPI　apiFrame :>> ", apiFrame);

            // 使用枚数を1で固定
            store.commit("ticketing/setStoreCountOfMultiSheets", 1);

            await API.validFrameWithQR(apiFrame.id, route.query.location_id);
          }
        }

        // ブック自体を初めて使う場合はブックをvalidにする処理を挟む
        if (!validBookInAdvance && !book.is_valid) {
          await bookService.executeValidBooks(
            bookGroup,
            masterBook.is_multi_validatable
          );
          await issueExternalCoupon();
        }

        nativeHandlerService.ncUseSheet(
          masterBook.id,
          bookGroup.id,
          book,
          masterBook.start_hour
        );

        return true;
      } catch (err) {
        console.log("executeValidAPI err :>> ", err);
        errorHandring(err.response.data.error);
        return false;
      }
    };

    // 複数モギリの券面の場合に表示されたダイアログで枚数を指定されたときに発火する関数
    const decideCountOfMultiSheetValid = (frames) => {
      console.log("decideCountOfMultiSheetValid :>> ", frames);
      // dataに枚数を持ち回るため代入
      multiSheetValidIdsArray.value = frames;

      // 枚数の確認ダイアログ表示
      DialogValidFramesConfirmation.value.openDialog();
    };

    const confirmationCanceled = () => {
      DialogValidFramesConfirmation.value.closeDialog();
      DialogSelectMultiValidFramesCount.value.openDialog();
    };

    const errorHandring = (err) => {
      console.log("errorHandring :>> ", err);
      actionDialog("DialogLoading", false);

      if (err == "valid_error_already_validated_another") {
        // PUT /books/:id/is_valid の同時利用エラーが valid_error_already_validated_another
        actionDialog("DialogAlreadyValidatedAnother", true);
      } else if (err == "max_concurrent_using_over") {
        // POST /valid_books  の同時利用エラーが max_concurrent_using_over
        actionDialog("DialogMaxConcurrentUsingOver", true);
      } else if (err == "invalid_use_interval") {
        // PUT /emergency_code?code=xxxxxx にてUseInterval内のため使用不可ダイアログ
        actionDialog("DialogInvalidUseInterval", true);
      } else {
        // それ以外の理由でのデフォルトエラー
        actionDialog("DialogValidFramesWithQRFails", true);
      }
    };

    const actionDialog = (dialog, action) => {
      DialogAction.value = { dialog: dialog, action: action };
    };

    const storeCountOfMultiSheets = computed(
      () => store.getters["ticketing/storeCountOfMultiSheets"]
    );

    return {
      decideCountOfMultiSheetValid,
      storeCountOfMultiSheets,
      executeValidAPI,
      validFrameAndGetSheetInfo,
      DialogAction,
      DialogValidFramesConfirmation,
      confirmationCanceled,
      DialogSelectMultiValidFramesCount,
      issueExternalCoupon,
    };
  },
};
</script>
